import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/* Providers */
import { GenericRequestProvider } from '../generic-request-provider';

@Injectable({
    providedIn: 'root'
})
export class MediaProvider extends GenericRequestProvider<any> {
    
    constructor(
        http: HttpClient
    ) {
      super('/api/midia', http);
    }
    
    getMidia(urlMidia: string): GenericRequestProvider<any> {
        return new GenericRequestProvider<any>(
          `api/app/${urlMidia}`,
          this.http
        );
    }

    getMidiaBlobVideo(conteudo: string, idConteudo: number, idMidia: number): GenericRequestProvider<any> {
        return new GenericRequestProvider<any>(`api/app/midia/${conteudo}/${idConteudo}/${idMidia}`, this.http);
    }

    upload(type: string): GenericRequestProvider<any> {
        return new GenericRequestProvider<any>(`api/midia/upload/${type}`, this.http);
    }
   
    upload1(type: Blob): GenericRequestProvider<any> {
        return new GenericRequestProvider<any>(`api/midia/upload/${type}`, this.http);
    }
}
